import { PlanningAPI } from "../../axios";

export const actions = {

    // PlanningRatingScale
    GetPlanningRatingScale(context, data){
        return PlanningAPI.get(`PlanningRatingScale/Target/${data}`);
    },
    GetSinglePlanningRatingScale(context, data){
        return PlanningAPI.get(`PlanningRatingScale/${data}`);
    },
    UpdatePlanningRatingScale(context, data){
        return PlanningAPI.put(`PlanningRatingScale`, data);
    },
    DeletePlanningRatingScale(context, data){
        return PlanningAPI.delete(`PlanningRatingScale/${data}`);
    },
    AddPlanningRatingScale(context, data){
        return PlanningAPI.post(`PlanningRatingScale`, data);
    },

}